<template>
  <TooltipProvider class="h-full">
    <router-view />
    <ToastManager />
    <UpsellSheet v-model="isUpsellSheetOpen" />
  </TooltipProvider>
</template>
<script lang="ts" setup>
import { useFavicon } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { TooltipProvider } from 'reka-ui'
import { onMounted } from 'vue'

import { useAuthStore } from '@/auth/useAuthStore'
import { useBrazeLifecycle } from '@/core/public/useBrazeLifecycle'
import { useHestiaPreload } from '@/features/hestia/composables/useHestiaPreload'
import UpsellSheet from '@/features/upsell/public/UpsellSheet.vue'
import { isUpsellSheetOpen } from '@/features/upsell/sheetState'
import { cobrowse } from '@/plugins/cobrowse'
import { FeatureFlags } from '@/plugins/featureFlags'

import ToastManager from './components/toasts/ToastManager.vue'
import { useLocaleHandler } from './composables/useLocaleHandler'
import { usePageTitle } from './composables/usePageTitle'
import { useIframeCookieRenewal } from './composables/useIframeCookieRenewal'
import { useSessionManager } from './composables/useSessionManager'

useHestiaPreload()
useLocaleHandler()
usePageTitle()
useSessionManager()
useIframeCookieRenewal()
useBrazeLifecycle()
useFavicon(
  import.meta.env.MODE !== 'production'
    ? '/favicon/favicon-dev.ico'
    : '/favicon/favicon.ico'
)

const { user } = storeToRefs(useAuthStore())
const updateFeatureFlagCtx = () => {
  if (user.value) {
    if (user.value.email) {
      FeatureFlags.setContextField('userId', user.value.email)
    } else {
      FeatureFlags.setContextField('userId', user.value.id)
    }
  }
}

onMounted(() => {
  updateFeatureFlagCtx()
  void cobrowse.load()
})
</script>
